import { render } from "./FarmingHeader.vue?vue&type=template&id=cd51d536&scoped=true&ts=true"
import script from "./FarmingHeader.vue?vue&type=script&lang=ts"
export * from "./FarmingHeader.vue?vue&type=script&lang=ts"

import "./FarmingHeader.vue?vue&type=style&index=0&id=cd51d536&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd51d536"]])

export default __exports__